export const STATUS_MESSAGES = {
    401: '請重新登入',
    403: '無權限存取',
    404: '找不到資源',
    500: '系統錯誤，請稍後再試',
    502: '系統維護中',
    504: '請求逾時，請稍後再試',
    "default": "發生錯誤，請稍後再試" 
};